import { useEffect, useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import { Button } from "./styles/HomePageButton.styled";
import { fetchSendEmailCode, getVerifyCode } from "../api/api";

interface ModalProps {
    show: boolean;
    onHide: Function;
    email: string;
    onVerifyPass: Function;
}

export const VerfiyModal = (props: ModalProps) => {
    const { show, onHide, email, onVerifyPass } = props;
    const [code, setCode] = useState<string>('');
    const [verifying, setVerifying] = useState(false);
    const [sendingCode, setSendingCode] = useState(false);
    const [codeError, setCodeError] = useState("");
    const [countdown, setCountdown] = useState(0);

    useEffect(()=>{
        if (sendingCode || verifying) return;
        if (show) {
            sendVerificationCode(email); 
        }
    },[show])


    const sendVerificationCode = async (email: string) => {
        setSendingCode(true);
        try {
            await fetchSendEmailCode(email);
            setCountdown(90);
            setCodeError("");
        } catch (err: any) {
            setCodeError(err.message || "Failed to send code.");
        } finally {
            setSendingCode(false);
        }
    };

      const handleVerifyCode = async () => {
    if (!code || code.length < 6) {
      return setCodeError("Please enter a valid verification code.");
    }

    setVerifying(true);
    try {
      const res = await getVerifyCode("email", email, code);
      if (res?.status === "1") {
        onVerifyPass();
      } else {
        setCodeError("Invalid verification code.");
      }
    } catch (err: any) {
      setCodeError(err.message || "Verification failed.");
    } finally {
      setVerifying(false);
    }
  };

    useEffect(() => {
    let timer: any;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

    return <Modal centered show={show} onHide={() => onHide()}>
        <Modal.Header closeButton>
            <Modal.Title>Email Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "20px" }}>
            <p className="mb-4">
                we sent code to <strong>{email}</strong>.
            </p>
            <Form.Control
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Enter code"
                maxLength={6}
            />
            {codeError && <p style={{ color: "red", marginTop: 8 }}>{codeError}</p>}
            <div className="d-flex justify-content-between align-items-center mt-4">
                <Button
                    onClick={handleVerifyCode}
                    disabled={verifying}
                    style={{ backgroundColor: "#6b8aff" }}
                >
                    {verifying ? <Spinner animation="border" size="sm" /> : "Verify & Submit"}
                </Button>
                <Button
                    onClick={() => sendVerificationCode(email)}
                    disabled={countdown > 0}
                    style={{
                        background: "transparent",
                        color: "#6b8aff",
                        border: "none",
                    }}
                >
                    {sendingCode ? (
                        <Spinner animation="border" size="sm" />
                    ) : countdown > 0 ? (
                        `Resend in ${countdown}s`
                    ) : (
                        "Resend Code"
                    )}
                </Button>
            </div>
        </Modal.Body>
    </Modal>
}